import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { WhitepaperspageService } from '../whitepaperspage.service';
import { CanonicalService } from 'src/app/shared/services/canonical.service';
import { WhitepaperArticleHeroComponent } from './whitepaper-article-hero/whitepaper-article-hero.component';
import { WhitepaperArticleApplyComponent } from './whitepaper-article-apply/whitepaper-article-apply.component';
import { WhitepaperArticleReReportComponent } from './whitepaper-article-re-report/whitepaper-article-re-report.component';
import { PosthogService } from 'src/app/shared/services/posthog.service';

@Component({
  selector: 'app-whitepaper-article',
  templateUrl: './whitepaper-article.component.html',
  styleUrls: ['./whitepaper-article.component.scss'],
  imports: [
    WhitepaperArticleHeroComponent,
    WhitepaperArticleApplyComponent,
    WhitepaperArticleReReportComponent,
  ],
})
export class WhitepaperArticleComponent implements OnInit, OnDestroy {
  getStartedData:any;
  pageData: any;
  constructor(
    private activeRoute: ActivatedRoute,
    private whitePaperspageService: WhitepaperspageService,
    private canonical: CanonicalService,
    private posthogService: PosthogService
  ) {
    this.subscriptions = [];
  }

  subscriptions: Subscription[];

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  async ngOnInit(): Promise<void> {
    this.canonical.setCanonicalURL();
    const wId = this.activeRoute.snapshot?.params?.['whitepaperid'];
    if (!wId) return;
    
    const fetchedData = await this.whitePaperspageService.getAllWhitepaperArticles();
    if (!fetchedData || !Array.isArray(fetchedData)) return;
    
    this.pageData = fetchedData.filter(
      (el: any) => el?.fields?.blogId?.toLowerCase() === wId.toLowerCase()
    )[0];
    
    let data = this.pageData?.fields;
    if (data != null) {
      this.getStartedData = {
        header: data?.gettingStarted?.fields?.title,
        button1: {
          url: data?.gettingStarted?.fields?.buttons?.[0]?.fields?.redirectLink,
          text: data?.gettingStarted?.fields?.buttons?.[0]?.fields?.buttonText,
          target:
            data?.gettingStarted?.fields?.buttons?.[0]?.fields?.actionType,
        },
        button2: {
          url: data?.gettingStarted?.fields?.buttons?.[1]?.fields?.redirectLink,
          text: data?.gettingStarted?.fields?.buttons?.[1]?.fields?.buttonText,
          target:
            data?.gettingStarted?.fields?.buttons?.[1]?.fields?.actionType,
        },
      };
    }
    this.posthogService.capturePageViewEvent(wId);
  }
}
